import { useDropzone } from "vue3-dropzone";
import { v4 as uuidv4 } from 'uuid';

const template = `
<div class="col col-sm-3"  >
	<div v-if="wait" class="d-flex justify-content-center">
		<div class="spinner-border" role="status">
		<span class="visually-hidden">Loading...</span>
		</div>
	</div>

	<div v-else>
		<img :src="media.src" style="width:70px" class="rounded" v-if="media.type === 'img'">
		<video muted style="width:70px" class="rounded" v-if="media.type === 'video'">
			<source :src="media.src" type="video/mp4" />
			<p>Your browser does not support HTML5 videos.</p>
		</video>
	</div>

	<div class="text-center">
		<button class="btn btn-white btn-sm ms-1" v-if="messageOk" @click="cancelImg" > 
			Cancel
		</button>
	</div>
</div>
<div class="col text-center col-sm-9">
	<div type="button" class="h-100 py-3 border border-2 bg-white rounded" v-bind="dropGeneralPicture.getRootProps()">
		<input v-bind="dropGeneralPicture.getInputProps()" />
		<span v-if="dropGeneralPicture.isDragActive">Drop the file to upload</span>
		<span class="align-middle" v-else :class="messageErreur?'text-danger':''">
			<div v-show="messageErreur">
				{{messageErreur}}
			</div>
			<div>
				Drag file here, <br/> or click to upload.
			</div>
		</span>
	</div>
</div>
<slot></slot>
`

const dropzonePage = {
	props: {
		original: String,	// url originale de l'image
		index: Number, // index de l'element en cours dans la boucle
		type: String
	},
	emits: ["modifie"], // quand une image est modifiée, envoie le nom de l'image.
	data() {
		const thisVue = this;

		const verifierExtension = async (nomFichier) => {
			const parties = nomFichier.split('.');

			if (parties.length > 1) {
				const extension = parties.pop().toLowerCase();
				return (extension === 'jpg' || extension === 'png') ? 'img' : 'video'
			}
		};

		async function onDrop(acceptFiles, rejectReasons) {
			//
			//console.log("rejectReasons",rejectReasons)
			if (acceptFiles && acceptFiles.length) {
				thisVue.wait = true;
				thisVue.messageErreur = "";
				thisVue.messageOk = "";
				//
				try {
					const acceptFile = acceptFiles[0];

					const preview = await verifierExtension(acceptFile.name)

					let formData = new FormData();
					formData.append('file_to_upload', acceptFile);  // Here fileField is the input file reference
					if (preview === 'img') {
						formData.append('thumbnailWidth', 'tac');
					}
					formData.append('path', acceptFile.path);

					//
					const tempName = "drozonevue_" + uuidv4();
					const url = "dropzone/temp/" + tempName;
					const settings = {
						method: 'POST',
						headers: { Accept: 'application/json' },
						body: formData
					};
					const fetchResponse = await fetch(url, settings);
					//
					if (fetchResponse.status === 200) {
						let donnee = await fetchResponse.json();

						thisVue.media.src = (donnee.thumb) ? "attachment/temp/" + donnee.thumb + "?timestamp=" + Date.now() : "";

						if (preview === 'img') thisVue.media.type = 'img'
						if (preview === 'video') thisVue.media.type = 'video'

						thisVue.messageOk = "Ok";
						//
						thisVue.$emit('modifie', tempName, preview, thisVue.index);
						//
					} else {
						let donnee = await fetchResponse.json();
						thisVue.messageErreur = "Invalid image format";
					}
				} catch (e) {
					thisVue.messageErreur = e.message || e
				}
				thisVue.wait = false;
			}
			//
			//
		}

		let acceptFile = null
		if (thisVue.preview === 'img') acceptFile = 'image/*'
		if (thisVue.preview === 'video') acceptFile = 'video/*'

		const { getRootProps, getInputProps, ...rest } = useDropzone({ onDrop, multiple: false, acceptFile });

		return {
			copieOriginal: this.original || null,
			media: {
				src: this.original || null,
				type: this.type || thisVue.media.type
			},
			wait: false,
			dropGeneralPicture: {
				getRootProps,
				getInputProps,
				...rest,
			},
			messageOk: "",
			messageErreur: "",
		}
	},

	methods: {
		cancelImg() {
			this.messageOk = false;
			this.media.src = this.copieOriginal;
			this.media.type = this.type;
			this.$emit('modifie', "", true);
		},
	},
	template
}

export { dropzonePage };